import { useEffect, useState } from "react";

const useFetch = (jsonPath) => {
  const [data, setData] = useState(null);
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${jsonPath}`);
        const jsonData = await response.json();
        setData(jsonData);
      } catch (error) {
        console.log(error, "Error Fetching Data")
      }
    };

    fetchData();
  }, [jsonPath]);

  return data;
};

export default useFetch;